export default __webpack_public_path__ + "HenrySans-Medium.787e8c4db718ebfb4161adb8a51e7112.woff2";